export function initNewsSlider() {
    $('.news-list-swiper').each(function () {
        const cards = $(this).find('.card-content');

        let max = 0;
        cards.each(function () {
            const height = $(this).height();
            if (max < height) {
                max = height;
            }
        });

        cards.height(max);
    });
}